module.exports = __webpack_public_path__ + "img/logo2.60c8a7e6.png";